import PaymentAlert from './PaymentAlert';

export default PaymentAlert;
